define('Toastr',['jquery', 'UI', 'JSTemplate'], function($, UI, template) {

    "use strict";
    return function(options) {

        var defaults = {
                'class': 'toastr-success',
                'close-button': true,
                'timeout': 3000,
                'position': 'bottom-center',
                'message': 'Default message',
                'template': 'tplToastr',
                'icon': 'ion-checkmark'
            },

            o,

            _fadeToastr = function(that) {
                that.fadeOut('slow', function() {
                    that.remove();
                })
            },

            _bindEvents = function() {
                if (o.timeout) {
                    setTimeout(function() {
                        _fadeToastr($('.' + o.class));
                    }, o.timeout);
                }

                if (o['close-button']) {
                    UI.$b.off('click','.toastr-close').on('click', '.toastr-close', function(ev) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        var $parent = $(this).parent();
                        $parent.fadeOut('slow', function() {
                            $parent.remove();
                        });
                    });
                }

                UI.$b.off('click', '.toastr').on('click', '.toastr', function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    _fadeToastr($(this));
                });

            },

            _renderToastr = function() {
                $('.toastr').remove();

                var html = template(o.template, {
                    options: o
                });
                UI.$b.prepend(html);

            },

            init = function(options) {
                o = $.extend(defaults, options);
                _renderToastr();
                _bindEvents();
            };

        init(options);
    };

});
